<div class="container-fluid" style="max-width: 1200px;">
    <h1 class="m-3 display-6 vm-container-header"><i class="bi bi-box-seam me-2"></i>Product Groups</h1>

    <div class="pb-5">
        <div class="m-3 p-2 bg-body-light rounded-3 shadow">
            <div class="m-2">
                <form>
                    <div class="mb-3 row align-items-center">
                        <div class="col-sm-auto">
                            <select (change)="this.onCustomerChange($event)" aria-label="Select a customer" class="form-select">
                                <option selected>Select a Customer</option>
                                @for (entity of this.customers; track entity.id) {
                                    <option value="{{ entity.id }}">{{ entity.name }}</option>
                                }
                            </select>
                        </div>

                        <app-table-search [(value)]="this.service.searchTerm" />
                    </div>
                </form>

                @if (!!this.customerId && ((this.total$ | async) ?? 0) > 0) {
                    <table class="table table-striped table-hover">
                        <caption>
                            <div class="container-fluid">
                                <div class="row justify-content-center align-self-center">
                                    <div class="col align-self-center">
                                        {{ this.total$ | async }} Total
                                    </div>
                                    <div class="col text-end">
                                        <button type="button" class="btn btn-sm btn-outline-primary bi bi-plus-circle" (click)="onAdd()" title="Add product group">
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </caption>

                        <thead>
                        <tr>
                            <th (sort)="this.onSort($event)" scope="col" sortable="name">Name</th>
                            <th (sort)="this.onSort($event)" scope="col" sortable="memberCount" class="text-center">Products</th>
                            <th scope="col" class="text-center">Actions</th>
                        </tr>
                        </thead>

                        <tbody class="table-group-divider">
                            @for (element of this.service.data$ | async; track element.id) {
                                <tr>
                                    <td class="align-middle col-7">
                                        {{ element.name }}
                                        @if (element.isAllProducts) {
                                            <span class="badge text-bg-secondary ms-2" title="System-managed group: every product is visible. It cannot be renamed, deleted, or edited.">
                                                <i class="bi bi-lock-fill"></i>
                                            </span>
                                        }
                                    </td>
                                    <td class="align-middle text-center col-3">{{ element.memberCount }}</td>
                                    <td class="align-middle text-center col-2">
                                        @if (!element.isAllProducts) {
                                            <div class="btn-group" role="group">
                                                <i class="btn btn-sm btn-outline-primary bi bi-box-seam" title="Manage products" (click)="onManageProducts(element)"></i>
                                                <i class="btn btn-sm btn-outline-primary bi bi-pencil" title="Rename" (click)="onEdit(element)"></i>
                                                <i class="btn btn-sm btn-outline-danger bi bi-trash" title="Delete" (click)="onDelete(element)"></i>
                                            </div>
                                        } @else {
                                            <span class="text-muted small"><i class="bi bi-dash"></i></span>
                                        }
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                }

                @if (!!this.customerId && ((this.total$ | async) ?? 0) > 0) {
                    <app-table-pager [total]="(this.total$ | async)!" [(page)]="this.service.page" [(pageSize)]="this.service.pageSize" />
                }

                @if (!this.customerId) {
                    <div class="card text-center bg-info-subtle border border-info rounded p-3 m-5">
                        <div class="card-body">
                            <i class="bi bi-info-circle-fill me-2"></i>Select a customer to see its Product Groups.
                        </div>
                    </div>
                }

                @if (!!this.customerId && ((this.total$ | async) ?? 0) == 0 && !(this.globalService.waitOverlayIsVisible$ | async)) {
                    <div class="card text-center bg-warning-subtle border border-warning rounded p-3 m-5">
                        <div class="card-body">
                            <i class="bi bi-exclamation-triangle-fill me-2"></i>No product groups found.
                        </div>
                    </div>
                }
            </div>
        </div>

        <!-- Create -->
        <ng-template #createModal>
            <div class="modal-header">
                <h1 class="modal-title fs-5">New Product Group</h1>
                <button (click)="createModalRef.dismiss()" type="button" class="btn-close" aria-label="Close"></button>
            </div>
            <form [formGroup]="createForm" (ngSubmit)="onAddSubmit()">
                <div class="modal-body container-fluid">
                    <div class="form-floating mt-2">
                        <input type="text" class="form-control" id="createNameControl" formControlName="name" placeholder="Group name">
                        <label for="createNameControl" class="form-label">Name</label>
                        @if (createForm.controls.name.invalid && (createForm.controls.name.dirty || createForm.controls.name.touched)) {
                            <div class="alert alert-danger mt-2">
                                @if (createForm.controls.name.hasError('required')) { <div>Required</div> }
                            </div>
                        }
                    </div>
                </div>
                <div class="modal-footer">
                    <button [disabled]="savingData" type="submit" class="btn btn-primary">
                        @if (savingData) { <span class="spinner-border spinner-border-sm me-1"></span> }
                        Create
                    </button>
                    <button (click)="createModalRef.dismiss()" type="button" class="btn btn-secondary">Close</button>
                </div>
            </form>
        </ng-template>

        <!-- Rename -->
        <ng-template #editModal>
            <div class="modal-header">
                <h1 class="modal-title fs-5">Rename Product Group</h1>
                <button (click)="editModalRef.dismiss()" type="button" class="btn-close" aria-label="Close"></button>
            </div>
            <form [formGroup]="editForm" (ngSubmit)="onEditSubmit()">
                <div class="modal-body container-fluid">
                    <div class="form-floating mt-2">
                        <input type="text" class="form-control" id="editNameControl" formControlName="name" placeholder="Group name">
                        <label for="editNameControl" class="form-label">Name</label>
                        @if (editForm.controls.name.invalid && (editForm.controls.name.dirty || editForm.controls.name.touched)) {
                            <div class="alert alert-danger mt-2">
                                @if (editForm.controls.name.hasError('required')) { <div>Required</div> }
                            </div>
                        }
                    </div>
                </div>
                <div class="modal-footer">
                    <button [disabled]="savingData" type="submit" class="btn btn-primary">
                        @if (savingData) { <span class="spinner-border spinner-border-sm me-1"></span> }
                        Save
                    </button>
                    <button (click)="editModalRef.dismiss()" type="button" class="btn btn-secondary">Close</button>
                </div>
            </form>
        </ng-template>

        <!-- Manage products (dual-list transfer) -->
        <ng-template #manageModal>
            <div class="modal-header">
                <h1 class="modal-title fs-5">Manage Products — {{ manageGroup()?.name }}</h1>
                <button (click)="manageModalRef.dismiss()" type="button" class="btn-close" aria-label="Close"></button>
            </div>
            <div class="modal-body container-fluid">
                @if (membershipLoading()) {
                    <div class="text-center p-4">
                        <span class="spinner-border"></span>
                        <div class="mt-2">Loading products…</div>
                    </div>
                } @else {
                    <div class="row g-2 align-items-stretch">
                        <!-- Available -->
                        <div class="col-5 d-flex flex-column">
                            <h6 class="text-center">Available ({{ filteredAvailable().length }})</h6>
                            <input type="text" class="form-control form-control-sm mb-2" placeholder="Search available…"
                                   [ngModel]="availableSearch()" (ngModelChange)="availableSearch.set($event)">
                            <div class="list-group overflow-auto border rounded" style="height: 45vh;">
                                @for (p of filteredAvailable(); track p.id) {
                                    <button type="button"
                                            class="list-group-item list-group-item-action"
                                            [class.active]="selectedAvailable().has(p.id)"
                                            (click)="toggleAvailable(p.id)">
                                        {{ p.description }}
                                    </button>
                                }
                                @empty {
                                    <div class="list-group-item text-muted text-center">No products</div>
                                }
                            </div>
                        </div>

                        <!-- Move controls -->
                        <div class="col-2 d-flex flex-column justify-content-center align-items-center gap-2">
                            <button type="button" class="btn btn-outline-primary"
                                    [disabled]="filteredAvailable().length === 0"
                                    (click)="moveAllToMembers()" title="Add all shown to group">
                                <i class="bi bi-chevron-double-right"></i>
                            </button>
                            <button type="button" class="btn btn-outline-primary"
                                    [disabled]="selectedAvailable().size === 0"
                                    (click)="moveToMembers()" title="Add selected to group">
                                <i class="bi bi-chevron-right"></i>
                            </button>
                            <button type="button" class="btn btn-outline-primary"
                                    [disabled]="selectedMember().size === 0"
                                    (click)="moveToAvailable()" title="Remove selected from group">
                                <i class="bi bi-chevron-left"></i>
                            </button>
                            <button type="button" class="btn btn-outline-primary"
                                    [disabled]="filteredMembers().length === 0"
                                    (click)="moveAllToAvailable()" title="Remove all shown from group">
                                <i class="bi bi-chevron-double-left"></i>
                            </button>
                        </div>

                        <!-- Members -->
                        <div class="col-5 d-flex flex-column">
                            <h6 class="text-center">In group ({{ filteredMembers().length }})</h6>
                            <input type="text" class="form-control form-control-sm mb-2" placeholder="Search members…"
                                   [ngModel]="memberSearch()" (ngModelChange)="memberSearch.set($event)">
                            <div class="list-group overflow-auto border rounded" style="height: 45vh;">
                                @for (p of filteredMembers(); track p.id) {
                                    <button type="button"
                                            class="list-group-item list-group-item-action"
                                            [class.active]="selectedMember().has(p.id)"
                                            (click)="toggleMember(p.id)">
                                        {{ p.description }}
                                    </button>
                                }
                                @empty {
                                    <div class="list-group-item text-muted text-center">No products assigned</div>
                                }
                            </div>
                        </div>
                    </div>
                }
            </div>
            <div class="modal-footer">
                <button [disabled]="savingMembership() || membershipLoading() || !membershipDirty" type="button"
                        class="btn btn-primary" (click)="onSaveMembership()">
                    @if (savingMembership()) { <span class="spinner-border spinner-border-sm me-1"></span> }
                    Save
                </button>
                <button (click)="manageModalRef.dismiss()" type="button" class="btn btn-secondary">Close</button>
            </div>
        </ng-template>

        <app-modal-confirm #confirmationModal></app-modal-confirm>
    </div>
</div>
